module.exports = __webpack_public_path__ + "static/img/bg.42dbb961.png";